export const iconFontAwesomeScienceSkullCrossbones = (
	<i className="fa-solid fa-skull-crossbones"></i>
);
